import styled from 'styled-components';

// Warning-colored (yellow/orange) dismissible popup. Floats over content on the
// right side, below the top menus, with a high z-index — mirroring the Sidenav
// Announcement popup pattern (position: absolute/fixed + large z-index).
export const Banner = styled.div`
  position: fixed;
  top: 90px;
  right: 24px;
  /* Sits above page content but below the MUI Drawer modal (z-index 1300),
     so the Contact Details drawer covers the announcement when open. */
  z-index: 1100;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  max-width: 700px;
  padding: 14px 16px;
  background: #fff4e5;
  border: 1px solid #ffb020;
  border-left: 4px solid #ffb020;
  border-radius: 12px;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.18);
  color: #7a4d00;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;

  @media screen and (max-width: 768px) {
    top: auto;
    bottom: 16px;
    right: 16px;
    left: 16px;
    max-width: none;
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  color: #ffb020;
  font-size: 20px;
  flex-shrink: 0;
`;

export const Text = styled.span`
  flex-grow: 1;
  line-height: 1.4;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #7a4d00;
  flex-shrink: 0;
  transition: color 0.2s ease-in;

  &:hover {
    color: #4d3000;
  }
`;
